import { FIND_TAG_REQUEST, findTagSuccess, findTagFailure} from 'Redux/Action';
import { ofType } from 'redux-observable';
import { from, EMPTY } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { TEpic } from "Redux/Config";

export const findTagEpic:TEpic = (action$, store$, { TagRepository }) => {
    return action$.pipe(
        ofType(FIND_TAG_REQUEST),
        mergeMap( action =>{
            const { id } = action.payload;

            if(!id.trim()) {
                return EMPTY;
            }

            return from(
                TagRepository.findById( id )
                    .then(tag => findTagSuccess(tag))
                    .catch(error => findTagFailure(error)),
            );
        }),
    );
}
